import { Dialog, type Props as DialogProps } from '~/components/Dialog/Dialog';
import { Button } from '~/components/Button/Button';
import { Portal } from '@headlessui/react';

type Props = Omit<DialogProps, 'children'> & {
  onConfirm: () => void;
};

export function UnsavedChangesDialog({ isOpen, onClose, onConfirm }: Props) {
  return (
    <Portal>
      <Dialog isOpen={isOpen} onClose={onClose}>
        <Dialog.Title>Du har osparade ändringar</Dialog.Title>

        <Dialog.Text>
          Om du lämnar sidan nu går dina ändringar förlorade. Vill du fortsätta?
        </Dialog.Text>

        <Button.Group align="right">
          <Button variant="secondary" onClick={onClose}>
            Stanna kvar
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Lämna sidan
          </Button>
        </Button.Group>
      </Dialog>
    </Portal>
  );
}
